import { createFileRoute } from '@tanstack/react-router'

import PageUserManagement from '@/pages/PageUserManagement'

export const Route = createFileRoute('/settings/users')({
  component: PageUserManagement
})
